var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/compose/components/polls/poll-form.tsx";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { addPollOption, changePollOption, changePollSettings, clearComposeSuggestions, fetchComposeSuggestions, removePoll, removePollOption, selectComposeSuggestion } from 'soapbox/actions/compose';
import AutosuggestInput from 'soapbox/components/autosuggest-input';
import { Button, Divider, HStack, Stack, Text, Toggle } from 'soapbox/components/ui';
import { useAppDispatch, useAppSelector, useCompose } from 'soapbox/hooks';
import DurationSelector from './duration-selector';
const messages = defineMessages({
  option_placeholder: {
    "id": "compose_form.poll.option_placeholder",
    "defaultMessage": "Answer #{number}"
  },
  add_option: {
    "id": "compose_form.poll.add_option",
    "defaultMessage": "Add an answer"
  },
  pollDuration: {
    "id": "compose_form.poll.duration",
    "defaultMessage": "Duration"
  },
  removePoll: {
    "id": "compose_form.poll.remove",
    "defaultMessage": "Remove poll"
  },
  switchToMultiple: {
    "id": "compose_form.poll.switch_to_multiple",
    "defaultMessage": "Change poll to allow multiple answers"
  },
  switchToSingle: {
    "id": "compose_form.poll.switch_to_single",
    "defaultMessage": "Change poll to allow for a single answer"
  },
  minutes: {
    "id": "intervals.full.minutes",
    "defaultMessage": "{number, plural, one {# minute} other {# minutes}}"
  },
  hours: {
    "id": "intervals.full.hours",
    "defaultMessage": "{number, plural, one {# hour} other {# hours}}"
  },
  days: {
    "id": "intervals.full.days",
    "defaultMessage": "{number, plural, one {# day} other {# days}}"
  },
  multiSelect: {
    "id": "compose_form.poll.multiselect",
    "defaultMessage": "Multi-Select"
  },
  multiSelectDetail: {
    "id": "compose_form.poll.multiselect_detail",
    "defaultMessage": "Allow users to select multiple answers"
  }
});

const Option = _ref => {
  let {
    composeId,
    index,
    maxChars,
    numOptions,
    onChange,
    onRemove,
    onRemovePoll,
    title
  } = _ref;
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const suggestions = useCompose(composeId).suggestions;

  const handleOptionTitleChange = event => onChange(index, event.target.value);

  const handleOptionRemove = () => {
    if (numOptions > 2) {
      onRemove(index);
    } else {
      onRemovePoll();
    }
  };

  const onSuggestionsClearRequested = () => dispatch(clearComposeSuggestions(composeId));

  const onSuggestionsFetchRequested = token => dispatch(fetchComposeSuggestions(composeId, token));

  const onSuggestionSelected = (tokenStart, token, value) => {
    if (token && typeof token === 'string') {
      dispatch(selectComposeSuggestion(composeId, tokenStart, token, value, ['poll', 'options', index]));
    }
  };

  return /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    justifyContent: "between",
    space: 4,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    space: 2,
    grow: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-6",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 76,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "bold",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 77,
      columnNumber: 11
    }
  }, index + 1, ".")), /*#__PURE__*/React.createElement(AutosuggestInput, {
    className: "rounded-md dark:!bg-transparent !bg-transparent",
    placeholder: intl.formatMessage(messages.option_placeholder, {
      number: index + 1
    }),
    maxLength: maxChars,
    value: title,
    onChange: handleOptionTitleChange,
    suggestions: suggestions,
    onSuggestionsFetchRequested: onSuggestionsFetchRequested,
    onSuggestionsClearRequested: onSuggestionsClearRequested,
    onSuggestionSelected: onSuggestionSelected,
    searchTokens: [':'],
    autoFocus: index === 0 || index >= 2,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 9
    }
  })), index > 1 && /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 96,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "danger",
    size: "sm",
    onClick: handleOptionRemove,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "compose_form.poll.remove_option",
    defaultMessage: "Delete",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 13
    }
  }))));
};

const PollForm = _ref2 => {
  var _compose$poll, _compose$poll2, _compose$poll3;

  let {
    composeId
  } = _ref2;
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const compose = useCompose(composeId);
  const pollLimits = useAppSelector(state => state.instance.getIn(['configuration', 'polls']));
  const options = (_compose$poll = compose.poll) === null || _compose$poll === void 0 ? void 0 : _compose$poll.options;
  const expiresIn = (_compose$poll2 = compose.poll) === null || _compose$poll2 === void 0 ? void 0 : _compose$poll2.expires_in;
  const isMultiple = (_compose$poll3 = compose.poll) === null || _compose$poll3 === void 0 ? void 0 : _compose$poll3.multiple;
  const maxOptions = pollLimits.get('max_options');
  const maxOptionChars = pollLimits.get('max_characters_per_option');

  const onRemoveOption = index => dispatch(removePollOption(composeId, index));

  const onChangeOption = (index, title) => dispatch(changePollOption(composeId, index, title));

  const handleAddOption = () => dispatch(addPollOption(composeId, ''));

  const onChangeSettings = (expiresIn, isMultiple) => dispatch(changePollSettings(composeId, expiresIn, isMultiple));

  const handleSelectDuration = value => onChangeSettings(value, isMultiple);

  const handleToggleMultiple = () => onChangeSettings(expiresIn, !isMultiple);

  const onRemovePoll = () => dispatch(removePoll(composeId));

  if (!options) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Stack, {
    space: 4,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 138,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    space: 2,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 139,
      columnNumber: 7
    }
  }, options.map((title, i) => /*#__PURE__*/React.createElement(Option, {
    composeId: composeId,
    title: title,
    key: i,
    index: i,
    onChange: onChangeOption,
    onRemove: onRemoveOption,
    maxChars: maxOptionChars,
    numOptions: options.size,
    onRemovePoll: onRemovePoll,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 141,
      columnNumber: 11
    }
  })), /*#__PURE__*/React.createElement(HStack, {
    space: 2,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 154,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-6",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 155,
      columnNumber: 11
    }
  }), options.size < maxOptions && /*#__PURE__*/React.createElement(Button, {
    theme: "secondary",
    onClick: handleAddOption,
    size: "sm",
    block: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 158,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.add_option, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 164,
      columnNumber: 15
    }
  }))))), /*#__PURE__*/React.createElement(Divider, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 170,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleToggleMultiple,
    className: "text-left",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 172,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center",
    justifyContent: "between",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 173,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 174,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 175,
      columnNumber: 13
    }
  }, intl.formatMessage(messages.multiSelect)), /*#__PURE__*/React.createElement(Text, {
    theme: "muted",
    size: "sm",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 179,
      columnNumber: 13
    }
  }, intl.formatMessage(messages.multiSelectDetail))), /*#__PURE__*/React.createElement(Toggle, {
    checked: isMultiple,
    onChange: handleToggleMultiple,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 184,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(Divider, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 188,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(Stack, {
    space: 2,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 191,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    weight: "medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 192,
      columnNumber: 9
    }
  }, intl.formatMessage(messages.pollDuration)), /*#__PURE__*/React.createElement(DurationSelector, {
    onDurationChange: handleSelectDuration,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 196,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 200,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "text-danger-500",
    onClick: onRemovePoll,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 201,
      columnNumber: 9
    }
  }, intl.formatMessage(messages.removePoll))));
};

export default PollForm;